// extracted by mini-css-extract-plugin
export var actionButton = "_j9-t";
export var buttonContainer = "_j9-0";
export var buttonContainer2 = "_j9-1";
export var buttonSection = "_j9-2";
export var details = "_j9-3";
export var dropdownItem = "_j9-5";
export var dropdownItemsContainer = "_j9-4";
export var fileInput = "_j9-r";
export var headerButton = "_j9-6";
export var icon = "_j9-7";
export var input = "_j9-8";
export var macroListItem = "_j9-9";
export var mainContent = "_j9-a";
export var microText = "_j9-b";
export var modal = "_j9-w";
export var optionsButton = "_j9-c";
export var paperclip = "_j9-s";
export var pillContent = "_j9-d";
export var preview = "_j9-e";
export var preview2 = "_j9-f";
export var quillEditor = "_j9-q";
export var selectedMacro = "_j9-g";
export var sidebar = "_j9-h";
export var sidebarHeader = "_j9-j";
export var sidebarList = "_j9-i";
export var sidebarListItem = "_j9-k";
export var sidebarSearch = "_j9-l";
export var snoozeDurationWrapper = "_j9-v";
export var statusPillContainer = "_j9-m";
export var tagsContainer = "_j9-n";
export var unselectedMacro = "_j9-o";
export var variable = "_j9-u";
export var wrapper = "_j9-p";